<template>
  <DefaultHeader class="relative z-10000">
    <DashboardNavigation slot="navigation">
      <!-- slot to fill buttons -->
      <slot />
    </DashboardNavigation>
  </DefaultHeader>
</template>

<script>
import DashboardNavigation from '@/components/dashboard/DashboardNavigation'
import DefaultHeader from '@/components/DefaultHeader'

export default {
  components: { DashboardNavigation, DefaultHeader },
}
</script>
